angular.module('note')
    .component('noteBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/note/_btn-options.html',
        controller: function (Note, NoteService, FilesLibrary, FilesSimpleUploadService) {
            this.FilesLibrary = FilesLibrary;
            this.FilesSimpleUploadService = FilesSimpleUploadService;
            this.fileResourceName = "NOTE"

            this.canEdit = () => true;

            this.edit = entityId => Note.get({id: entityId}, entity => NoteService.editModal(entity))
            this.delete = entry => NoteService.remove(entry);
        }
    })
